const RENTALS = [
  {
    rank: '#1',
    name: 'Glen Falls Luxury Cabin',
    location: 'Highlands, NC — Near Glen Falls',
    recommendation: 'Top Overall Pick',
    rating: '5.0',
    ratingLabel: 'Airbnb Guest Favorite',
    bestFor: 'Couples, families, and anyone wanting a luxury mountain experience with privacy and easy access to town and waterfalls',
    description: 'Glen Falls Luxury Cabin sits in a secluded, wooded setting just a few minutes\' drive from downtown Highlands and Main Street — close enough to walk to dinner, private enough to feel like a true retreat. The cabin is within walking distance of Glen Falls waterfall, one of the most beautiful in the region, making it an ideal base for both outdoor time and town. Thoughtfully designed with upscale finishes, indoor and outdoor fireplaces, a covered deck, and a full kitchen, it delivers a genuine luxury mountain experience without feeling overdone. It holds a 5.0-star Airbnb Guest Favorite rating — one of the highest in the area — with guests consistently noting the quality of the space, the peaceful setting, and the attentive hosting.',
    features: ['Pet Friendly', 'Near Glen Falls Waterfall', 'Indoor Stone Fireplace', 'Outdoor Wood-Burning Fireplace', 'Covered Deck', 'Minutes from Downtown Highlands', 'Secluded Wooded Setting', '5.0 Guest Favorite'],
    href: 'https://glenfallscabin.com',
    img: 'https://storage.readdy-site.link/project_files/3bf9208c-726c-4b4e-b038-214aec1b6878/82b5623f-a9a4-4c1a-aebf-7b48fe50828d____glen-falls-luxury-cabin-fire-pit.jpg?v=1d670368f3ca182b7ebb0bf842226bc0',
    featured: true,
  },
  {
    rank: '#2',
    name: 'Laurelwood',
    location: 'Highlands, NC',
    recommendation: null,
    rating: '4.9',
    ratingLabel: 'VRBO',
    bestFor: 'Guests looking for a classic mountain cabin feel with a peaceful wooded setting',
    description: 'A well-rated cabin rental in Highlands, NC set among mature trees. Comfortable, peaceful, and well-located for guests who want a classic mountain escape with easy access to local trails and downtown Highlands. A solid choice for those who want a quieter, more traditional cabin experience.',
    features: ['Wooded Setting', 'Mountain Cabin', 'Close to Trails', 'Highlands, NC'],
    href: 'https://www.vrbo.com/9585180ha',
    img: 'https://storage.readdy-site.link/project_files/3bf9208c-726c-4b4e-b038-214aec1b6878/8f8e8e50-db78-4f16-98ad-df783523f5fb_lauralwood.jpg?v=b217c2d0ed1fd424e03a6182cc825629',
    featured: false,
  },
  {
    rank: '#3',
    name: 'Falls Drive Cottage',
    location: 'Highlands, NC — Falls Drive',
    recommendation: null,
    rating: '4.88',
    ratingLabel: 'VRBO',
    bestFor: 'Travelers who want to be close to the waterfalls and enjoy a quiet, nature-immersed stay',
    description: 'A cozy, well-located cottage along Falls Drive — one of the most scenic roads in Highlands, NC. Positioned close to the waterfall trails and surrounded by natural beauty, it\'s a solid choice for guests who want to be immersed in the outdoors while still having easy access to town.',
    features: ['Near Waterfalls', 'Scenic Falls Drive Location', 'Cozy Cottage', 'Nature Setting'],
    href: 'https://www.vrbo.com/9708237ha',
    img: 'https://storage.readdy-site.link/project_files/3bf9208c-726c-4b4e-b038-214aec1b6878/2fc20e78-0610-46ea-8d08-42512d4cd546_falls-drive-cottage.jpg?v=ff1f3173554355082858f4dde89f4624',
    featured: false,
  },
  {
    rank: '#4',
    name: 'Whispering Walk',
    location: 'Highlands, NC — Wooded Neighborhood',
    recommendation: null,
    rating: '4.91',
    ratingLabel: 'VRBO',
    bestFor: 'Guests seeking maximum privacy and calm in a quiet wooded setting',
    description: 'A tranquil cabin rental in a quiet wooded neighborhood in Highlands, NC. A good fit for guests seeking privacy and calm, with easy access to the natural beauty of the surrounding area. The setting is peaceful and the neighborhood is quiet — ideal for a true escape.',
    features: ['Peaceful Setting', 'Wooded Neighborhood', 'Private Retreat', 'Highlands, NC'],
    href: 'https://www.vrbo.com/9342676ha',
    img: 'https://storage.readdy-site.link/project_files/3bf9208c-726c-4b4e-b038-214aec1b6878/9b9a737d-38ca-412e-b0c4-550bddbd2b96_whisphering-walk.jpg?v=903da70d418fbb5ef0fe0e04a9c868aa',
    featured: false,
  },
  {
    rank: '#5',
    name: 'Stag Ridge — Luxury Highlands Escape',
    location: 'Highlands, NC — Wooded Ridge',
    recommendation: null,
    rating: '4.9',
    ratingLabel: 'Airbnb',
    bestFor: 'Families or groups wanting a spacious luxury cabin with pet-friendly accommodations',
    description: 'A thoughtfully designed luxury forest cabin in Highlands, NC with a wraparound deck, indoor stone fireplace, full kitchen, and BBQ grill. Pet friendly and accommodating up to 6 guests, it\'s a strong option for families or groups who want more space and a refined mountain setting.',
    features: ['Pet Friendly', 'Indoor Stone Fireplace', 'Wraparound Deck', 'Full Kitchen & BBQ', 'Sleeps 6', 'Wooded Ridge'],
    href: 'https://www.airbnb.com/rooms/1180227781183226897',
    img: 'https://static.readdy.ai/image/ad5520ee7149a263b01f4e3410f2d685/46fa8df15f4549c7bb8d2bc9e3c35336.jpeg',
    featured: false,
  },
];

export default function VRRankedListSection() {
  return (
    <section className="bg-[#FAFAF8] py-24 px-6 lg:px-14">
      <div className="max-w-7xl mx-auto">

        {/* Section header */}
        <div className="text-center mb-5">
          <p className="text-[#C9A96E] text-xs tracking-[0.3em] uppercase font-jost mb-4">/ Verified Listings</p>
          <h2 className="font-cormorant text-5xl text-[#1A1A18] font-light">
            Top Vacation Rentals in<br /><em className="italic">Highlands, NC</em>
          </h2>
        </div>
        <p className="text-[#5C5850] font-jost text-sm leading-relaxed max-w-2xl mx-auto text-center mb-14">
          Here are some of the best <strong className="text-[#2D4A3E] font-medium">vacation rentals in Highlands, NC</strong>, ranked by guest ratings, location, and overall experience. All properties are real and link directly to their booking pages.
        </p>

        <div className="space-y-8">
          {RENTALS.map((rental) => (
            <article
              key={rental.name}
              className={`rounded-2xl overflow-hidden flex flex-col lg:flex-row ${rental.featured ? 'bg-white' : 'bg-white'}`}
            >
              {/* Image */}
              <a
                href={rental.href}
                target="_blank"
                rel="noopener noreferrer"
                className={`relative shrink-0 block group cursor-pointer overflow-hidden ${rental.featured ? 'lg:w-[48%] h-72 lg:h-auto min-h-[380px]' : 'lg:w-[38%] h-60 lg:h-auto min-h-[280px]'}`}
              >
                <img
                  src={rental.img}
                  alt={`${rental.name} — vacation rental in Highlands NC`}
                  className="w-full h-full object-cover object-top transition-transform duration-700 group-hover:scale-105"
                />
                {/* Rank badge */}
                <div className={`absolute top-4 left-4 font-jost font-bold tracking-widest rounded-full px-3 py-1.5 text-sm ${rental.featured ? 'bg-[#C9A96E] text-white' : 'bg-white/90 text-[#C9A96E]'}`}>
                  {rental.rank}
                </div>
                {rental.featured && (
                  <div className="absolute top-4 right-4 flex items-center gap-1.5 bg-[#2D4A3E] text-white text-xs tracking-[0.15em] uppercase font-jost px-3 py-1.5 rounded-full">
                    <div className="w-3 h-3 flex items-center justify-center">
                      <i className="ri-award-line text-[#C9A96E] text-xs" />
                    </div>
                    Top Pick
                  </div>
                )}
                {/* Rating */}
                <div className="absolute bottom-4 left-4 flex items-center gap-1.5 bg-white/95 backdrop-blur-sm px-3 py-1.5 rounded-full">
                  <div className="w-3.5 h-3.5 flex items-center justify-center">
                    <i className="ri-star-fill text-[#C9A96E] text-xs" />
                  </div>
                  <span className="text-[#1A1A18] text-xs font-jost font-semibold">{rental.rating}</span>
                  <span className="text-[#9C9890] text-xs font-jost">· {rental.ratingLabel}</span>
                </div>
              </a>

              {/* Content */}
              <div className={`flex-1 flex flex-col justify-between ${rental.featured ? 'p-8 lg:p-10' : 'p-7 lg:p-8'}`}>
                <div>
                  <div className="mb-3">
                    {rental.recommendation && (
                      <p className="text-[#2D4A3E] text-xs font-jost font-semibold tracking-[0.18em] uppercase mb-1.5">
                        {rental.recommendation}
                      </p>
                    )}
                    <a
                      href={rental.href}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="cursor-pointer"
                    >
                      <h3 className={`font-cormorant text-[#1A1A18] font-medium hover:text-[#2D4A3E] transition-colors leading-tight ${rental.featured ? 'text-3xl md:text-4xl' : 'text-2xl md:text-3xl'}`}>
                        {rental.name}
                      </h3>
                    </a>
                    <p className="text-[#9C9890] text-xs font-jost mt-1.5 flex items-center gap-1.5">
                      <span className="w-3 h-3 flex items-center justify-center">
                        <i className="ri-map-pin-2-line text-xs" />
                      </span>
                      {rental.location}
                    </p>
                  </div>

                  <p className={`text-[#5C5850] font-jost leading-relaxed mb-5 ${rental.featured ? 'text-sm' : 'text-sm'}`}>
                    {rental.description}
                  </p>

                  <div className="mb-5">
                    <p className="text-[#2D4A3E] text-xs font-jost font-semibold tracking-wide uppercase mb-2">Best For</p>
                    <p className="text-[#5C5850] text-sm font-jost italic">{rental.bestFor}</p>
                  </div>

                  <div className="flex flex-wrap gap-2 mb-6">
                    {rental.features.map((feature) => (
                      <span key={feature} className="text-xs font-jost px-3 py-1 rounded-full bg-[#EDE8E0] text-[#5C5850]">
                        {feature}
                      </span>
                    ))}
                  </div>
                </div>

                <a
                  href={rental.href}
                  target="_blank"
                  rel="noopener noreferrer"
                  className={`inline-flex items-center gap-2 text-xs font-jost tracking-[0.15em] uppercase px-6 py-3 rounded-full transition-all cursor-pointer whitespace-nowrap self-start ${rental.featured ? 'bg-[#2D4A3E] text-white hover:bg-[#1e3329]' : 'border border-[#2D4A3E] text-[#2D4A3E] hover:bg-[#2D4A3E] hover:text-white'}`}
                >
                  View Listing
                  <div className="w-3.5 h-3.5 flex items-center justify-center">
                    <i className="ri-external-link-line text-xs" />
                  </div>
                </a>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}
